import { Spin } from "antd"
import { LocalThemeProvider } from "providers/layout/ThemeProvider"
import { HorizontalCenter } from "./Center"
import { SpinSize } from "antd/es/spin";

const Spinner = (props: { white?: boolean, size?: SpinSize, style?: React.CSSProperties }) => {

    const size = props.size || "large";

    if (props.white) return (
        <LocalThemeProvider
            theme={{
                token: {
                    colorPrimary: "#FFFFFF",
                }
            }}
        ><HorizontalCenter style={{...props.style}}>
                <Spin size={size} />
            </HorizontalCenter>
        </LocalThemeProvider>
    )

    return (
        <HorizontalCenter style={{...props.style}}>
            <Spin size={size} />
        </HorizontalCenter>
    )

}

export default Spinner;
